import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { SharedService } from '../services/shared.service';
import { PatientService } from '../services/patient.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css']
})
export class PatientComponent implements OnInit, AfterViewInit {
  @ViewChild('patientNameInput', { static: false }) patientNameInput: ElementRef;
  showLoadingMessage = false;

  /** Full list from API (active + inactive), each item has isActive */
  allPatientDtos: any[] = [];
  residentName = '';
  /** Client-side filter: substring match on patient id (numeric id as string) */
  patientIdFilter = '';
  /** When true: show only inactive; when false: show only active */
  showOnlyInactive = false;

  constructor(
    private sharedService: SharedService,
    private patientService: PatientService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sharedService.reloadUserPrivileges();
    this.loadAllPatientDtos();
  }

  ngAfterViewInit(): void {
    if (this.patientNameInput && this.patientNameInput.nativeElement) {
      this.patientNameInput.nativeElement.focus();
    }
  }

  /** Load active and inactive lists once, merge with isActive flag */
  loadAllPatientDtos(): void {
    this.showLoadingMessage = true;
    const active$ = this.patientService.getPatientDtos(
      this.sharedService.pharmacyId,
      this.sharedService.facilityId,
      this.sharedService.getUserId(),
      true
    );
    const inactive$ = this.patientService.getPatientDtos(
      this.sharedService.pharmacyId,
      this.sharedService.facilityId,
      this.sharedService.getUserId(),
      false
    );
    forkJoin([active$, inactive$]).subscribe({
      next: ([activeList, inactiveList]) => {
        activeList.forEach((p: any) => (p.isActive = true));
        inactiveList.forEach((p: any) => (p.isActive = false));
        this.allPatientDtos = [...(activeList || []), ...(inactiveList || [])];
        this.showLoadingMessage = false;
      },
      error: () => (this.showLoadingMessage = false)
    });
  }

  /** Client-side filtered list: inactive/active, Resident Name, Patient ID (substring on id) */
  get filteredPatientDtos(): any[] {
    if (!this.allPatientDtos || this.allPatientDtos.length === 0) return [];
    let list = this.showOnlyInactive
      ? this.allPatientDtos.filter((p) => !p.isActive)
      : this.allPatientDtos.filter((p) => p.isActive);
    const term = (this.residentName || '').trim().toLowerCase();
    if (term) {
      list = list.filter((p) => {
        const fullName = `${p.lastName || ''} ${p.firstName || ''}`.toLowerCase();
        const fullNameReversed = `${p.firstName || ''} ${p.lastName || ''}`.toLowerCase();
        return fullName.includes(term) || fullNameReversed.includes(term);
      });
    }
    const idTerm = (this.patientIdFilter || '').trim();
    if (idTerm) {
      list = list.filter((p) => {
        const idStr = p.id != null ? String(p.id) : '';
        return idStr.indexOf(idTerm) !== -1;
      });
    }
    return list;
  }

  openProfile(patientId: number): void {
    this.router.navigate(['patient/profile/' + patientId]);
  }
}
